import React from "react";

export default function TeacherTitle({ main_teacher }) {
  return (
    <div className="build-title">
      <div className="journal-name">{main_teacher.fullname}</div>
    </div>
  );
}
